import { Component, Input } from '@angular/core';

@Component({
  selector: 'unh-svg-icon-legacy',
  styleUrls: ['./svg-icon.component.scss'],
  template: `
    <img [src]="svgurl" [alt]="title" [title]="title" [ngStyle]="this.customStyles" />
  `
})
export class SvgIconComponent {
  @Input() customStyles: { width: string, height: string } | object = {};
  @Input() svgurl: string;
  @Input() title = '';
}
